<h1>Nos articles de blog</h1>
<div class="px-2">
    <app-list-articles></app-list-articles>
</div>
